import React from 'react';
import FinancialTable from './FinancialTable';
import KPIGrid from './KPIGrid';
import InvoiceList from './InvoiceList';
import SimpleChart from './SimpleChart';

/**
 * ArtifactRenderer — Routes artifact objects to the right visual component.
 */
export default function ArtifactRenderer({ artifact }) {
  if (!artifact?.type) return null;

  switch (artifact.type) {
    case 'financial_table':
      return <FinancialTable artifact={artifact} />;
    case 'kpi_grid':
      return <KPIGrid artifact={artifact} />;
    case 'invoice_list':
      return <InvoiceList artifact={artifact} />;
    case 'bar_chart':
      return <SimpleChart artifact={artifact} />;
    default:
      return null;
  }
}
